import { FormControl } from '@angular/forms';

export class UtilsService {
  static sixLetterCodeCondition = (text: string) => text && text.length === 6;
  static factorCondition = (num: number) => Number.isInteger(Math.log10(num));
  static precisionCondition = (num: number) =>
    num >= 0 && num < 13 && Number.isInteger(num);
  static roundingCondition = (num: number) => {
    const log = Math.log10(num);
    return (
      num === 0 || (Number.isInteger(num) && Number.isInteger(log) && log < 5)
    );
  };

  static factorValidator() {
    return (control: FormControl): { [key: string]: boolean } | null => {
      const log = Math.log10(control.value);
      if (!Number.isInteger(log)) {
        return {
          factorValidator: true,
        };
      }
      return null;
    };
  }

  static roundingValidator() {
    return (control: FormControl): { [key: string]: boolean } | null => {
      if (control.value === 0) {
        return null;
      }
      const log = Math.log10(control.value);
      if (!Number.isInteger(log) || log > 4) {
        return {
          roundingValidator: true,
        };
      }
      return null;
    };
  }

  static isNotDefinedOrNull(value: any) {
    return value !== null && value !== undefined;
  }
}
